import ApiGenericServicesData from "service/ApiGenericServicesData";
import { codificarValorSeguro } from "util/codificarValorSeguro";

export default class ConstanciaAfiliacionAPartidosPoliticos extends ApiGenericServicesData {
  constructor() {
    super("constanciaAfiliacionAPartidosPoliticos");
  }

  async openFile(fileName) {
    const fileNameSeguro = await codificarValorSeguro(fileName);
    return this.customGET("openFile/" + fileNameSeguro);
  }
}
